import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { CajaMovimiento } from "@/shared/types/caja-movimiento";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface CajaActualMovimientosQuery extends BaseQuery {
    desde?: string,
    hasta?: string,
}

export async function getAllCajaActualAperturaActualMovimientos(query?: CajaActualMovimientosQuery): Promise<QueryResponse<CajaMovimiento>> {
    await sleep(1000);
    const response = await api.get("caja_actual/open/details", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllCajaActualAperturaActualMovimientosQuery(query: CajaActualMovimientosQuery = {}, queryConfig: QueryConfig<QueryResponse<CajaMovimiento>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllCajaActualAperturaActualMovimientos(query),
        queryKey: ["caja_actual", "open", "details", query],
    })
}

export interface GetAllCajaActualAperturaActualMovimientosQueryProps {
    query?: CajaActualMovimientosQuery,
    queryConfig?: QueryConfig<QueryResponse<CajaMovimiento>>,
    children: (queryResult: QueryResult<QueryResponse<CajaMovimiento>>) => ReactNode
}

export function GetAllCajaActualAperturaActualMovimientosQuery({
    query,
    queryConfig,
    children
}: GetAllCajaActualAperturaActualMovimientosQueryProps) {
    const queryResult = useGetAllCajaActualAperturaActualMovimientosQuery(query, queryConfig);
    return children && children(queryResult);
}